/**
 * Ashore API
 * All Endpoints to control your ashore account
 *
 * The version of the OpenAPI document: V1
 * Contact: info@ashoreapp.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The AccountChartSeriesRowData model module.
 * @module model/AccountChartSeriesRowData
 * @version V1
 */
class AccountChartSeriesRowData {
    /**
     * Constructs a new <code>AccountChartSeriesRowData</code>.
     * @alias module:model/AccountChartSeriesRowData
     */
    constructor() { 
        
        AccountChartSeriesRowData.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>AccountChartSeriesRowData</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/AccountChartSeriesRowData} obj Optional instance to populate.
     * @return {module:model/AccountChartSeriesRowData} The populated <code>AccountChartSeriesRowData</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new AccountChartSeriesRowData();

            if (data.hasOwnProperty('monthYearLabel')) {
                obj['monthYearLabel'] = ApiClient.convertToType(data['monthYearLabel'], 'String');
            }
            if (data.hasOwnProperty('firstOfTheMonthDate')) {
                obj['firstOfTheMonthDate'] = ApiClient.convertToType(data['firstOfTheMonthDate'], 'Date');
            }
            if (data.hasOwnProperty('value')) {
                obj['value'] = ApiClient.convertToType(data['value'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>AccountChartSeriesRowData</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>AccountChartSeriesRowData</code>.
     */
    static validateJSON(data) {
        // ensure the json data is a string
        if (data['monthYearLabel'] && !(typeof data['monthYearLabel'] === 'string' || data['monthYearLabel'] instanceof String)) {
            throw new Error("Expected the field `monthYearLabel` to be a primitive type in the JSON string but got " + data['monthYearLabel']);
        }

        return true;
    }


}



/**
 * @member {String} monthYearLabel
 */
AccountChartSeriesRowData.prototype['monthYearLabel'] = undefined;

/**
 * @member {Date} firstOfTheMonthDate
 */
AccountChartSeriesRowData.prototype['firstOfTheMonthDate'] = undefined;

/**
 * @member {Number} value
 */
AccountChartSeriesRowData.prototype['value'] = undefined;






export default AccountChartSeriesRowData;

